import React from 'react';
import {List, Map} from 'immutable';
import classNames from 'classnames';
import SelectField from 'components/pure/utils/form/SelectField';
import Button from '@material-ui/core/Button';
import './Tabs.styl';

export default class Tabs extends React.PureComponent {
  render() {
    const {onUpdateTab, activeTabId, tabRenderers, stats = Map(), dropdowns = List()} = this.props;
    // Object.keys should preserve the order in which the properties are defined
    const tabOrder = Object.keys(tabRenderers);
    const sortIndex = tabId => tabOrder.indexOf(tabId);
    const sortTabs = (a, b) => (sortIndex(a) < sortIndex(b) ? -1 : 1);

    const actualTabs = Object.entries(tabRenderers).map(([tabId, renderTab]) => {
      const values = stats.get(tabId, List()).map(stat => stat.value);
      return (
        <div
          className={classNames('tag-item', {
            active: tabId === activeTabId,
          })}
          key={tabId}
          onClick={() => onUpdateTab(tabId)}>
          <Button>{renderTab(values)}</Button>
        </div>
      );
    });

    const dropdownTabs = dropdowns.sort(sortTabs).map(tab => ({
      value: tab.id,
      label: tab.label,
    }));

    return (
      <nav className="ev-tabs">
        <div
          className={
            dropdownTabs.size > 0 ? 'tabs-container-with-dropdown' : 'tabs-container-no-dropdown'
          }>
          {actualTabs}
        </div>
        {dropdownTabs.size > 0 && (
          <div className="dropdown-container">
            <div className="drop-down">
              <SelectField
                placeholder="More ..."
                value={activeTabId}
                tether={true}
                options={dropdownTabs}
                onChange={tabId => onUpdateTab(tabId)}
              />
            </div>
          </div>
        )}
      </nav>
    );
  }
}
